<template>
  <v-app>
    <v-navigation-drawer v-model="drawer" app disable-resize-watcher class="hidden-lg-and-up mt-5">
      <v-list>
        <v-list>
          <v-list-tile>
            <v-btn flat to="/home/1">
              <v-icon>home</v-icon>
              <span class="pl-2">Home</span>
            </v-btn>
          </v-list-tile>
          <v-list-tile>
            <v-btn flat to="/home/2">
              <v-icon>face</v-icon>
              <span class="pl-2">About</span>
            </v-btn>
          </v-list-tile>
          <v-list-tile>
            <v-btn flat to="/home/3">
              <v-icon>work</v-icon>
              <span class="pl-2">Portfolio</span>
            </v-btn>
          </v-list-tile>
          <v-list-tile>
            <v-btn flat to="/garden">
              <v-icon>view_in_ar</v-icon>
              <span class="pl-2">Garden</span>
            </v-btn>
          </v-list-tile>
          <v-list-tile>
            <v-btn flat to="/resume">
              <v-icon>article</v-icon>
              <span class="pl-2">Résumé</span>
            </v-btn>
          </v-list-tile>
        </v-list>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar app scroll-off-screen>
      <v-toolbar-side-icon @click.stop="drawer = !drawer" class="hidden-lg-and-up"></v-toolbar-side-icon>
      <v-toolbar-title>
        <router-link to="/">
          <h2>BlakeJS</h2>
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-md-and-down">
        <v-btn flat to="/home/1">
          <v-icon>home</v-icon>
          <span class="pl-2 font-weight-bold">Home</span>
        </v-btn>
        <v-btn flat to="/home/2">
          <v-icon>face</v-icon>
          <span class="pl-2 font-weight-bold">About</span>
        </v-btn>
        <v-btn flat to="/home/3">
          <v-icon>work</v-icon>
          <span class="pl-2 font-weight-bold">Portfolio</span>
        </v-btn>
        <v-btn flat to="/garden">
          <v-icon>view_in_ar</v-icon>
          <span class="pl-2 font-weight-bold">Garden</span>
        </v-btn>
        <v-btn flat to="/resume">
          <v-icon>article</v-icon>
          <span class="pl-2 font-weight-bold">Résumé</span>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-content>
      <router-view />
    </v-content>
    <v-footer app>
      <span class="pa-2">&copy; 2024 - Built with ☕</span>
      <v-spacer class="hidden-lg-and-up"></v-spacer>
      <v-menu bottom left class="hidden-lg-and-up">
        <v-btn slot="activator" icon>
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile>
            <v-btn flat href="https://github.com/blakejs">
              <img src="/static/sprite/gh.svg" alt="Github" class="footer-sprite">
              <span class="pl-2">Github</span>
            </v-btn>
          </v-list-tile>
          <v-list-tile>
            <v-btn flat href="https://linkedin.com/in/blakejs">
              <img src="/static/sprite/link.svg" alt="Linkedin" class="footer-sprite">
              <span class="pl-2">LinkedIn</span>
            </v-btn>
          </v-list-tile>
          <v-list-tile>
            <v-btn flat href="https://blakejs.com/terms">
              <span class="pl-2">Terms & Privacy</span>
            </v-btn>
          </v-list-tile>
        </v-list>
      </v-menu>
      <div class="hidden-md-and-down">
        <v-btn flat href="https://github.com/blakejs">
          <img src="/static/sprite/gh.svg" alt="Github" class="footer-sprite">
          <span class="pl-2">Github</span>
        </v-btn>
        <v-btn flat href="https://linkedin.com/in/blakejs">
          <img src="/static/sprite/link.svg" alt="Linkedin" class="footer-sprite">
          <span class="pl-2">LinkedIn</span>
        </v-btn>
      </div>
      <div id="footer-terms-and-conditions" class="hidden-md-and-down">
        <v-list-tile>
          <v-btn flat href="https://blakejs.com/terms">
            <span class="pl-2">Terms & Privacy</span>
          </v-btn>
        </v-list-tile>
      </div>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      drawer: false
    };
  },
  name: "App"
};

</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Material+Icons&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Roboto+Mono&display=swap');

h2 {
  font-family: "Roboto Mono", monospace;
  font-size: 24px;
}

.v-toolbar {
  z-index: 9999 !important;
  background-color: #c6e5f1 !important;
}

.v-toolbar__title a {
  text-decoration: none;
  color: black;
}

.v-footer {
  z-index: 9999 !important;
  background-color: #c6e5f1 !important;
}

.footer-sprite {
  width: 20px !important;
}

.font-weight-bold {
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
}

#footer-terms-and-conditions {
  margin-left: auto;
}
</style>


// WEBPACK FOOTER //
// src/App.vue